const pad2 = n => String(n).padStart(2, '0');

/**
 * Formata duração em segundos de forma adaptativa:
 *   < 60s  → "42s"
 *   < 3600s → "2min 14s" ou "2min" (sem segundos zerados)
 *   ≥ 3600s → "1h 03min" ou "1h" (sem minutos zerados)
 */
export const fmtDur = s => {
  if (!s && s !== 0) return '—';
  const n = Math.round(Number(s));
  if (!n) return '0s';
  if (n < 60) return `${n}s`;
  if (n < 3600) {
    const m = Math.floor(n / 60);
    const ss = n % 60;
    return ss ? `${m}min ${ss}s` : `${m}min`;
  }
  const h = Math.floor(n / 3600);
  const m = Math.floor((n % 3600) / 60);
  return m ? `${h}h ${pad2(m)}min` : `${h}h`;
};

/**
 * Formata tempo de espera em fila (nunca retorna '—').
 */
export const fmtWait = secs => {
  if (secs < 60) return `${secs}s`;
  const m = Math.floor(secs / 60);
  if (m < 60) return `${m}min`;
  const h = Math.floor(m / 60);
  const rm = m % 60;
  return rm ? `${h}h ${rm}min` : `${h}h`;
};

/**
 * Calcula variação percentual entre período atual e anterior.
 * lowerIsBetter=true → queda é melhoria (verde).
 * Retorna { delta: "▼ 12,3%", dir: "up" } ou { delta: null, dir: "" }.
 */
export const pctDelta = (cur, prev, lowerIsBetter = true) => {
  if (!prev) return { delta: null, dir: '' };
  const pct = Math.abs(((cur - prev) / prev) * 100)
    .toFixed(1)
    .replace('.', ',');
  const improved = lowerIsBetter ? cur <= prev : cur >= prev;
  return {
    delta: `${improved ? '▼' : '▲'} ${pct}%`,
    dir: improved ? 'up' : 'down',
  };
};

/**
 * Score de cumprimento de SLA: quanto menor o tempo real vs. meta, melhor.
 * Retorna 0–100. Ex.: actual=30s, target=60s → 100 (dentro do prazo).
 */
export const slaScore = (actual, target) =>
  actual ? Math.max(0, Math.round(Math.min(100, (target / actual) * 100))) : 0;

/**
 * Agrega pontos brutos { timestamp (unix s), value } em média por hora do dia.
 * Ignora valores ≤ 0. Retorna array[24] com média ou null quando sem dados.
 */
export const aggregateMeanByHour = rawPoints => {
  const sum = Array(24).fill(0);
  const cnt = Array(24).fill(0);
  rawPoints.forEach(({ timestamp, value }) => {
    const hi = new Date(Number(timestamp) * 1000).getHours();
    const v = Number(value);
    if (v > 0) {
      sum[hi] += v;
      cnt[hi] += 1;
    }
  });
  return sum.map((s, i) => (cnt[i] ? s / cnt[i] : null));
};
